import React from 'react';
import './AppContainer.scss';

type Props = {
  children?: React.ReactNode;
};

const AppContainer: React.FC<Props> = ({ children }) => {
  return <div className={'container-with-nav'}>{children}</div>;
};
export default AppContainer;
